import { render } from "./DashboardFooter.vue?vue&type=template&id=79990db5&scoped=true"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"

import "./DashboardFooter.vue?vue&type=style&index=0&id=79990db5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79990db5"]])

export default __exports__